import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function scrollToPricing() {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    scrollToPricing();
  };
  return <a href="#pricing" onClick={handleClick} className={`block w-full rounded-lg bg-brand-green px-3 py-3 text-center font-heading text-[15px] uppercase leading-tight tracking-wide text-brand-navy shadow-[0_5px_0_0_#749A00] transition duration-150 hover:-translate-y-0.5 hover:bg-[#9DCC00] focus:outline-none focus:ring-4 focus:ring-brand-green/40 active:translate-y-0.5 active:shadow-[0_2px_0_0_#749A00] sm:text-lg ${className}`} data-id="element-43" data-mp="2ty1q5v991ds7">
      {children}
    </a>;
}
export function ProductImageLink({
  src,
  alt,
  className = ''
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  return <button type="button" onClick={scrollToPricing} className="block w-full focus:outline-none focus:ring-2 focus:ring-brand-green" aria-label="Aller à la section d'achat" data-id="element-44" data-mp="19aptmvbruefr">
      <img src={src} alt={alt} className={`mx-auto w-full object-contain transition-transform duration-200 hover:scale-[1.02] ${className}`} data-id="element-45" data-mp="1ibnw396kadw8" />
    </button>;
}